const getFloat = (number) => {
    if (typeof number === 'number') {
        return number / 100;
    }

    /* If the value is part of a percentage grouping, get the value according to whether the user inputted a
     * decimal greater than 1, a decimal less than 1, or just an integer. */
    let value = number;
    const isFirstCharZeroOrDecimal = value[0] === '0' || value[0] === '.' || value[0] === ',';

    if (isFirstCharZeroOrDecimal) {
        // i.e. 0.25 or 0,25 or .24
        value = parseFloat(value.replace(',', '.'));
    } else if (value.indexOf(',') > -1 || value.indexOf('.') > -1) {
        // i.e. 1.23 or 11,9
        value = parseFloat(value.replace(',', '.')) / 100;
    } else {
        // i.e. 80
        value = parseFloat(value) / 100;
    }

    return value;
};

export default getFloat;
